"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _translate = require("../utils/dom/translate");

var _numbers = require("../utils/numbers");

var _element = require("../utils/dom/element");

var _styles = require("../styles");

var _Scroll = _interopRequireDefault(require("../Scroll"));

var _Scroll2 = require("../Scroll/Scroll");

var _Colgroup = _interopRequireDefault(require("./Colgroup"));

var _Thead = _interopRequireDefault(require("./Thead"));

var _Tbody = _interopRequireDefault(require("./Tbody"));

var _is = require("../utils/is");

var _Td = require("./Td");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SeperateTable =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(SeperateTable, _PureComponent);

  function SeperateTable(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      currentIndex: 0,
      scrollLeft: 0,
      scrollTop: 0,
      floatFixed: true
    };
    _this.bindTbody = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'tbody');
    _this.bindRealTbody = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'realTbody');
    _this.bindThead = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'thead');
    _this.bindHeadWrapper = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'headWrapper');
    _this.setRowHeight = _this.setRowHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleColgroup = _this.handleColgroup.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleSortChange = _this.handleSortChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.cachedRowHeight = [];
    _this.lastScrollTop = 0;
    if (props.tableRef) props.tableRef(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = SeperateTable.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    this.adjustScrollLeft();
  } // reset scrollTop when data changed
  ;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var columns = this.props.columns;
    if (!this.tbody) return;
    if (this.props.data !== prevProps.data) this.resetHeight();
    if (columns !== prevProps.columns || columns.length !== prevProps.columns.length) this.resetWidth();
    this.updateScrollLeft();
  };

  _proto.getIndex = function getIndex(scrollTop) {
    if (scrollTop === void 0) {
      scrollTop = this.state.scrollTop;
    }

    var _this$props = this.props,
        data = _this$props.data,
        rowsInView = _this$props.rowsInView;
    var max = data.length;
    var mcf = scrollTop > 0.5 ? Math.ceil : Math.floor;
    var index = mcf(scrollTop * max - rowsInView * scrollTop);
    if (index > max - rowsInView) index = max - rowsInView;
    if (index < 0) index = 0;
    return index;
  };

  _proto.getContentHeight = function getContentHeight() {
    if (!this.props.data) return 0;
    return this.getSumHeight(0, this.props.data.length);
  };

  _proto.getContentWidth = function getContentWidth() {
    if (this.props.width) return this.props.width;
    if (this.tbody) return this.tbody.offsetWidth;
    return 0;
  };

  _proto.getSumHeight = function getSumHeight(start, end) {
    var rowHeight = this.props.rowHeight;
    var height = 0;

    for (var i = start; i < end; i++) {
      height += this.cachedRowHeight[i] || rowHeight;
    }

    return height;
  };

  _proto.getLastRowHeight = function getLastRowHeight(index) {
    var _this$props2 = this.props,
        rowHeight = _this$props2.rowHeight,
        data = _this$props2.data,
        rowsInView = _this$props2.rowsInView;
    if (index + rowsInView >= data.length) return 0;
    var lastRowHeight = 0;

    if (index >= 1 && index < data.length / 2) {
      lastRowHeight = this.cachedRowHeight[index - 1] || rowHeight;
    }

    return lastRowHeight;
  };

  _proto.setRowHeight = function setRowHeight(height, index) {
    var oldHeight = this.cachedRowHeight[index];
    this.cachedRowHeight[index] = height;
    if (!this.tbody) return;
    var _this$state = this.state,
        offsetLeft = _this$state.offsetLeft,
        currentIndex = _this$state.currentIndex;

    if (currentIndex === index && !oldHeight) {
      this.lastScrollTop += height - this.props.rowHeight;
      (0, _translate.setTranslate)(this.tbody, "-" + offsetLeft + "px", "-" + this.lastScrollTop + "px");
    }

    if (oldHeight && height !== oldHeight) {
      this.setState({
        scrollTop: this.lastScrollTop / this.getContentHeight()
      });
    }
  };

  _proto.updateScrollLeft = function updateScrollLeft() {
    var scrollLeft = this.props.scrollLeft;
    this.resetFloatFixed();
    if (!(0, _is.isNumber)(scrollLeft)) return;
    var args = this.lastScrollArgs && this.lastScrollArgs.slice();

    if (scrollLeft !== this.state.offsetLeft && args) {
      var bodyWidth = this.lastScrollArgs[4];
      if (scrollLeft < 0) scrollLeft = 0;
      if (scrollLeft > this.getContentWidth() - bodyWidth) scrollLeft = this.getContentWidth() - bodyWidth;
      args[0] = scrollLeft / (this.getContentWidth() - args[4]);
      args[1] = this.state.scrollTop;
      args[6] = 0;
      args[7] = 0;
      this.handleScroll.apply(this, args);
    }
  };

  _proto.adjustScrollLeft = function adjustScrollLeft() {
    var scrollLeft = this.props.scrollLeft;
    this.resetFloatFixed();

    if ((0, _is.isNumber)(scrollLeft) && scrollLeft > 0) {
      var v = this.headWrapper.clientWidth;
      var offset = this.getContentWidth() - v;
      this.setState({
        scrollLeft: scrollLeft / offset,
        offsetLeft: scrollLeft
      });
    }
  };

  _proto.resetFloatFixed = function resetFloatFixed() {
    if (!this.headWrapper || !this.tbody) return;
    var fixed = this.props.fixed;
    var delta = fixed === 'x' ? 0 : _Scroll2.BAR_WIDTH;
    var floatFixed = Math.abs(this.headWrapper.clientWidth - this.tbody.clientWidth) !== delta;

    if (floatFixed !== this.state.floatFixed) {
      this.setState({
        floatFixed: floatFixed
      });
    }
  };

  _proto.resetHeight = function resetHeight() {
    var _this2 = this;

    var _this$state2 = this.state,
        scrollTop = _this$state2.scrollTop,
        offsetLeft = _this$state2.offsetLeft;
    var treeColumnsName = this.props.treeColumnsName;
    var fullHeight = this.getContentHeight();
    var height = fullHeight * scrollTop;

    if (this.lastScrollTop - height >= 1) {
      this.lastScrollTop = height;
      var index = this.getIndex(scrollTop);
      setTimeout(function () {
        _this2.setState({
          currentIndex: index
        });
      });

      if (treeColumnsName) {
        this.tbody.style.marginTop = this.lastScrollArgs[5] * scrollTop + "px";
        (0, _translate.setTranslate)(this.tbody, "-" + offsetLeft + "px", "-" + this.lastScrollTop + "px");
        return;
      }

      if (index === 0) {
        this.tbody.style.marginTop = '0px';
        (0, _translate.setTranslate)(this.tbody, "-" + offsetLeft + "px", '0px');
      } else {
        (0, _translate.setTranslate)(this.tbody, "-" + offsetLeft + "px", "-" + this.lastScrollTop + "px");
      }
    } else if (this.lastScrollTop - height < 1) {
      setTimeout(function () {
        _this2.setState({
          scrollTop: _this2.lastScrollTop / fullHeight
        });
      });
    }
  };

  _proto.resetWidth = function resetWidth(left, right) {
    if (left === void 0) {
      left = this.lastResetLeft || 0;
    }

    if (right === void 0) {
      right = this.lastResetRight || 0;
    }

    this.lastResetLeft = left;
    this.lastResetRight = right;
    (0, _translate.setTranslate)(this.tbody, "-" + left + "px", "-" + this.lastScrollTop + "px");
    (0, _translate.setTranslate)(this.thead, "-" + left + "px", '0');
    [this.thead, this.tbody].forEach(function (el) {
      ;
      [].forEach.call(el.parentNode.querySelectorAll('td, th'), function (cell) {
        if (cell.classList.contains((0, _styles.tableClass)(_Td.CLASS_FIXED_LEFT))) {
          (0, _translate.setTranslate)(cell, left + "px", '0');
        } else if (cell.classList.contains((0, _styles.tableClass)(_Td.CLASS_FIXED_RIGHT))) {
          (0, _translate.setTranslate)(cell, "-" + right + "px", '0');
        } else if (cell.style.transform) {
          (0, _translate.setTranslate)(cell, '0', '0');
        }
      });
    });
  };

  _proto.bindElement = function bindElement(key, el) {
    this[key] = el;
  };

  _proto.scrollToIndex = function scrollToIndex(index, callback) {
    if (!this.$isMounted) return;
    if (index > 1) index -= 1;
    if (index < 0) index = 0;
    var contentHeight = this.getContentHeight();
    var outerHeight = (0, _element.getParent)(this.realTbody, "." + (0, _styles.tableClass)('body')).clientHeight - 12;
    var sumHeight = this.getSumHeight(0, index);
    var scrollTop = sumHeight / contentHeight;
    var marginTop = scrollTop * outerHeight;
    var offsetScrollTop = sumHeight + marginTop;

    if (offsetScrollTop > contentHeight) {
      offsetScrollTop = contentHeight;
      index = this.props.data.length - this.props.rowsInView;
      scrollTop = 1;
      marginTop = outerHeight;
    }

    this.setState({
      currentIndex: index,
      scrollTop: scrollTop
    }, callback);
    this.lastScrollTop = offsetScrollTop;
    this.tbody.style.marginTop = marginTop + "px";
    (0, _translate.setTranslate)(this.tbody, "-" + this.state.offsetLeft + "px", "-" + offsetScrollTop + "px");
  } // business component needed
  ;

  _proto.scrollOffset = function scrollOffset(index, callback) {
    var currentIndex = this.state.currentIndex;
    var outerHeight = (0, _element.getParent)(this.realTbody, "." + (0, _styles.tableClass)('body')).clientHeight - 12;
    var lastRowHeight = this.cachedRowHeight[this.cachedRowHeight.length - 1];
    if (this.state.scrollTop === 1 && index >= 0) return;
    if (lastRowHeight && this.realTbody.clientHeight - outerHeight < lastRowHeight && index >= 0) return;
    var scrollIndex = currentIndex + index + 1;

    if (currentIndex === 1 && index === -1) {
      scrollIndex = 0;
    }

    this.scrollToIndex(scrollIndex, callback);
  };

  _proto.handleScroll = function handleScroll() {
    if (!this.tbody || this.realTbody.clientHeight === 0) return;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var x = args[0],
        y = args[1],
        max = args[2],
        bar = args[3],
        v = args[4],
        h = args[5],
        pixelX = args[6],
        pixelY = args[7];
    this.lastScrollArgs = args;
    var _this$props3 = this.props,
        data = _this$props3.data,
        rowHeight = _this$props3.rowHeight,
        rowsInView = _this$props3.rowsInView;
    var contentWidth = this.getContentWidth();
    var contentHeight = this.getContentHeight();
    var left = x * (contentWidth - v);
    var scrollTop = h > contentHeight ? 0 : y;
    var right = max - left;
    if (right < 0) right = 0;
    /* set x */

    if (left < 0) left = 0;
    this.resetWidth(left, right);
    /* set x end */

    /* set y */

    this.tbody.style.marginTop = scrollTop * h + "px";

    if (pixelY === undefined) {
      // drag scroll bar
      var index = this.getIndex(scrollTop);
      var lastRowHeight = this.getLastRowHeight(index);
      var offsetScrollTop = this.getSumHeight(0, index) + scrollTop * this.realTbody.clientHeight;
      this.setState({
        currentIndex: index
      });
      this.lastScrollTop = offsetScrollTop;
      (0, _translate.setTranslate)(this.tbody, "-" + left + "px", "-" + (offsetScrollTop + lastRowHeight) + "px");
    } else if (pixelY === 0) {
      // whell x
      (0, _translate.setTranslate)(this.tbody, "-" + left + "px", "-" + this.lastScrollTop + "px");
    } else if (contentHeight < h) {
      this.lastScrollTop = 0;
      scrollTop = 0;
      (0, _translate.setTranslate)(this.tbody, "-" + left + "px", '0px');
      this.setState({
        currentIndex: 0
      });
    } else {
      // wheel scroll
      this.lastScrollTop += pixelY;
      if (this.lastScrollTop < 0) this.lastScrollTop = 0; // scroll over bottom

      if (this.lastScrollTop > contentHeight) this.lastScrollTop = contentHeight;
      var temp = this.lastScrollTop - scrollTop * h;
      var _index = 0;

      while (temp > 0) {
        temp -= this.cachedRowHeight[_index] || rowHeight;
        _index += 1;
      } // offset last row


      _index -= 1;
      if (data.length - rowsInView < _index) _index = data.length - rowsInView;
      if (_index < 0) _index = 0;
      this.setState({
        currentIndex: _index
      });
      scrollTop = this.lastScrollTop / contentHeight;
      (0, _translate.setTranslate)(this.tbody, "-" + left + "px", "-" + this.lastScrollTop + "px");
    }
    /* set y end */


    this.setState({
      scrollLeft: x,
      scrollTop: scrollTop,
      offsetLeft: left,
      offsetRight: right
    });
    if (this.props.onScroll) this.props.onScroll(x, y, left);
  };

  _proto.handleSortChange = function handleSortChange() {
    var _this$props4;

    this.scrollToIndex(0);

    (_this$props4 = this.props).onSortChange.apply(_this$props4, arguments);
  };

  _proto.handleColgroup = function handleColgroup(tds) {
    var columns = this.props.columns;
    var colgroup = [];

    var _loop = function _loop(i, count) {
      var width = tds[i].offsetWidth;
      var colSpan = parseInt(tds[i].getAttribute('colspan'), 10);

      if (colSpan > 1) {
        (0, _numbers.split)(width, (0, _numbers.range)(colSpan).map(function (j) {
          return columns[i + j].width;
        })).forEach(function (w) {
          return colgroup.push(w);
        });
      } else {
        colgroup.push(width);
      }
    };

    for (var i = 0, count = tds.length; i < count; i++) {
      _loop(i, count);
    }

    this.setState({
      colgroup: colgroup
    });
  };

  _proto.renderBody = function renderBody(floatClass) {
    var _this$props5 = this.props,
        data = _this$props5.data,
        rowsInView = _this$props5.rowsInView,
        columns = _this$props5.columns,
        width = _this$props5.width,
        fixed = _this$props5.fixed,
        rowHeight = _this$props5.rowHeight,
        others = _objectWithoutPropertiesLoose(_this$props5, ["data", "rowsInView", "columns", "width", "fixed", "rowHeight"]);

    var _this$state3 = this.state,
        colgroup = _this$state3.colgroup,
        scrollTop = _this$state3.scrollTop,
        scrollLeft = _this$state3.scrollLeft,
        offsetLeft = _this$state3.offsetLeft,
        offsetRight = _this$state3.offsetRight,
        currentIndex = _this$state3.currentIndex;
    var contentWidth = this.getContentWidth();

    if (!data || data.length === 0) {
      return _react.default.createElement("div", {
        key: "body"
      });
    }

    var dataUpdated = this.lastData !== data; // Incorrect height due to changing data length dynamically

    if (this.lastData && !dataUpdated) dataUpdated = this.lastData.length !== data.length;
    this.lastData = data;
    var prevHeight = this.getSumHeight(0, currentIndex);
    var hasNotRenderRows = data.length > rowsInView;
    return _react.default.createElement(_Scroll.default, {
      key: "body",
      scrollTop: scrollTop,
      scrollLeft: scrollLeft,
      scroll: fixed,
      scrollHeight: this.getContentHeight(),
      scrollWidth: contentWidth,
      onScroll: this.handleScroll,
      className: _styles.tableClass.apply(void 0, ['body'].concat(floatClass))
    }, _react.default.createElement("div", {
      ref: this.bindTbody,
      className: (0, _styles.tableClass)('scroll-inner'),
      style: {
        width: width
      }
    }, _react.default.createElement("div", {
      style: {
        height: prevHeight
      }
    }), _react.default.createElement("table", {
      style: {
        width: width
      },
      ref: this.bindRealTbody
    }, _react.default.createElement(_Colgroup.default, {
      colgroup: colgroup,
      columns: columns
    }), _react.default.createElement(_Tbody.default, _extends({}, others, {
      columns: columns,
      onBodyRender: this.handleColgroup,
      index: currentIndex,
      offsetLeft: offsetLeft,
      offsetRight: offsetRight,
      data: data.slice(currentIndex, currentIndex + rowsInView),
      setRowHeight: this.setRowHeight,
      hasNotRenderRows: hasNotRenderRows,
      dataUpdated: dataUpdated
    })))));
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        columns = _this$props6.columns,
        fixed = _this$props6.fixed,
        width = _this$props6.width;
    var _this$state4 = this.state,
        colgroup = _this$state4.colgroup,
        scrollLeft = _this$state4.scrollLeft,
        floatFixed = _this$state4.floatFixed;
    var floatClass = [];

    if (floatFixed) {
      if (scrollLeft > 0) {
        floatClass.push('float-left');
      }

      if (scrollLeft !== 1) {
        floatClass.push('float-right');
      }
    }

    if (fixed === 'y' || fixed === 'both') {
      floatClass.push('scroll-y');
    }

    return [_react.default.createElement("div", {
      key: "head",
      className: _styles.tableClass.apply(void 0, ['head'].concat(floatClass)),
      ref: this.bindHeadWrapper
    }, _react.default.createElement("table", {
      style: {
        width: width
      },
      ref: this.bindThead
    }, _react.default.createElement(_Colgroup.default, {
      colgroup: colgroup,
      columns: columns
    }), _react.default.createElement(_Thead.default, _extends({}, this.props, {
      onSortChange: this.handleSortChange
    })))), this.renderBody(floatClass)];
  };

  return SeperateTable;
}(_component.PureComponent);

SeperateTable.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'size', 'type', 'kengen'), {
  columns: _propTypes.default.array.isRequired,
  data: _propTypes.default.array,
  fixed: _propTypes.default.string.isRequired,
  onScroll: _propTypes.default.func,
  rowHeight: _propTypes.default.number,
  rowsInView: _propTypes.default.number.isRequired,
  tableRef: _propTypes.default.func,
  width: _propTypes.default.number,
  scrollLeft: _propTypes.default.number
});
SeperateTable.defaultProps = {
  data: undefined,
  rowHeight: 40,
  width: undefined
};
var _default = SeperateTable;
exports.default = _default;